import React, { Component } from 'react';
import Panel from '../../../../../../components/angle/Panel/index';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ViewClientForm from '../../components/ClientForm';

import {
    fetchCountries,
    fetchStates
} from '../../../../../../services/redux/commonData/actions';

class ViewClientPanel extends Component {
    componentDidMount() {
        let { fetchCountries, fetchStates } = this.props;
        fetchCountries();
        fetchStates();
    }

    render() {
        let { clientInformation, commonData, buttons } = this.props;

        return (
            <Panel
                showHeader
                header="View Client"
                showFooter
                footerComponents={buttons}
            >
                <div>
                    <ViewClientForm
                        clientData={clientInformation.editClientData}
                        countryList={commonData.countries}
                        stateList={commonData.states}
                        isEditable={false}
                    />
                </div>
            </Panel>
        );
    }
}

const mapStateToProps = state => ({
    clientInformation: state.employee.clientInformation,
    commonData: state.commonData
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchCountries,
            fetchStates
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(ViewClientPanel));



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/ClientInformation/screens/ViewClient/ViewClientPanel.js